import { Component, Input, ViewChild, ElementRef,  EventEmitter, } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common-services/common.service';
import { downloadFiles } from '../../utils';
import {
  FileType,
  USER_ROLE_KEYS,
  USER_ROLE_KEYS_LABELS,
  UserType,
  ChatMetaData,
  EntityType
} from '../../constants/constants';
import { UploadDndComponent } from '../upload-dnd/upload-dnd.component';
import { environment } from 'src/environments/environment';
interface NewComment {
  textMessage: string;
  createdOn?: number;
  userName: string;
  chatRefId?: number;
  entityType: string;
  entityId: number | undefined;
}

interface Comment {
  createdOn: any;
  id: number;
  chatRefId: number;
  textMessage: string;
  reatedOn: number;
  read: boolean;
  sender: string;
  receiver: string;
  userName:string;
}

export interface RFQInfo {
  id: number;
  rfqName: string;
}

@Component({
  selector: 'app-chatbox',
  templateUrl: './chatbox.component.html',
  styleUrls: ['./chatbox.component.scss'],
  //standalone: true,
})
export class ChatboxComponent {
  baseUrl = environment.BASE_URL;
  @Input() rfqInfo!: RFQInfo;
  // @Input() id!: number;
  comment: string = '';
  commentsList: Comment[] = [];
  fileList: any[] = [];
  @ViewChild('scrollMe') private commentScrollContainer!: ElementRef;
  uploadedDocumentInfo!: any;
  fileUploadConfig: any;
  resetFileUpload = true;
  showCheckboxes = false;
  nextRole = '';
  isSpecialShare: any;

  documentInfo: any;
  fileLocation = '';
  isShareBtnDisable: boolean = true;

  currReceiver = USER_ROLE_KEYS.Customer;
  customerUserName = sessionStorage.getItem('customerUserName') || '';

  constructor(
    private toastr: ToastrService,
    private commonService: CommonService,
  ) {}

  ngOnInit(): void {
    this.scrollToBottom();
    this.getChatById();    
  }
  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  scrollToBottom(): void {
    if (this.commentScrollContainer?.nativeElement) {
      this.commentScrollContainer.nativeElement.scrollTop =
        this.commentScrollContainer.nativeElement.scrollHeight;
    }
  }
  handleFileUpload(fileUploadEvent: any): void {
    this.uploadedDocumentInfo = fileUploadEvent;

    this.uploadedDocumentInfo.attachment.forEach((item: any) => {
      item.isChecked = false; // Set default value
    });

    if (fileUploadEvent.attachment.length === 0) {
      this.isShareBtnDisable = true;
      return;
    }

    this.isShareBtnDisable = false;
  }
  downloadFile(name: string, id: number) {
    downloadFiles(this.baseUrl, this.commonService, this.toastr, id, name);
  }

  postNewChat(newComment: NewComment) {
    let updateChatId = false;
    if (!newComment.chatRefId) {
      updateChatId = true;
    }
    this.commonService
      .postDatawithoutHeaders(
        `${this.baseUrl}chat-Library/common-chat/new-chat?service=RFQ`,
        newComment,
      )
      .subscribe({
        next: (data: any) => {
          this.comment = '';
          this.getChatById();
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error('error while adding new comment');
          console.log(error);
        },
      });
  }
  getChatById() {
    const payload = {
      entityType: EntityType.RFQ_CUSTOMER,
      entityId: this.rfqInfo.id,
    };
    this.commonService
      .postDatawithoutHeaders(
        `${this.baseUrl}chat-Library/common-chat/get-all-chat?service=RFQ`,
        payload,
      )
      .subscribe({
        next: (data: any) => {
          //reset state
          this.fileList = [];
          this.commentsList = [];

          //segregating comments and files
          data.response?.forEach((obj: any) => {
            if (obj.textMessage != null) {
              this.commentsList.push(obj);
            } else if (obj.fileObj != null) {
              this.fileList.push({ ...obj, isChecked: false });
            }
          });

          // if (!this.metaData.hasNewComment) {
          //   this.updateChatById();
          // }
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error('Error while getting comments');
          console.log(error);
        },
      });
  }

  // updateChatById() {
  //   const commentIds: any = [];
  //   this.commentsList.forEach((comment: any) => {
  //     commentIds.push(comment.id);
  //   });
  //   const payload = {
  //     //receiver: this.metaData.receivers,
  //     idList: commentIds,
  //   };

  //   this.commonService
  //     .update(
  //       `${this.baseUrl}chat-Library/common-chat/update-chat?service=RFQ`,
  //       '',
  //       payload,
  //     )
  //     .subscribe({
  //       next: (data: any) => {
  //         console.log('comment read status updated', data.response);
  //       },
  //       error: (error: HttpErrorResponse) => {
  //         this.toastr.error('error while getting comments');
  //         console.log(error);
  //       },
  //     });
  // }
  updateDataFunc(): void {
    const payload: NewComment = {
      textMessage: this.comment,
      userName: this.customerUserName,
      //chatRefId: this.chatRefId,
      entityType: EntityType.RFQ_CUSTOMER,
      entityId: this.rfqInfo.id,
    };
    this.postNewChat(payload);
  }

  trackComment(index: number, comment: any) {
    return comment ? comment.id : undefined;
  }
  private createFileConfigObject() {
    //change
    return {
      uploadLabel: 'Upload File',
      buttonName: 'Choose File',
      dragDropText: 'Drag & Drop File or',
      maxFileText: '(Max file size: 100MB)',
      isMultiple: true,
      fileSizeLimit: 10485760, // 10 mb in bytes
      fileLocation: this.fileLocation,
      fileFormats: '.pdf',
    };
  }
  submitUploadedFiles() {
    this.isShareBtnDisable = true;

    const url = `${this.baseUrl}chat-Library/common-chat/new-chat?service=RFQ`;

    const payload = {
      textMessage: "hiii",
      entityType: EntityType.RFQ_CUSTOMER,
      entityId: this.rfqInfo.id,
      userName: this.customerUserName
    };

    this.commonService.postDatawithoutHeaders(url, payload).subscribe({
      next: (data: any) => {
        this.comment = '';
        this.getChatById();
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error('Error while adding new comment');
        this.isShareBtnDisable = false;
        console.log(error);
      },
    });
  }
  close = () => {};
}
